// TermsPage.jsx
import React from "react";
import { LOOP_LEGAL_TERMS_VERSION, LOOP_LEGAL_UPDATED_LABEL, LOOP_SUPPORT_EMAIL } from "../utils/legalVersions";

const SECTIONS = [
  {
    "title": "1. Quiénes somos",
    "body": "Loop Reservas es operado por Loop Software S.A. (“Loop”, “nosotros” o “la plataforma”). Estos términos aplican a clientes, negocios, administradores, trabajadores autorizados y cualquier persona que use Loop Reservas.",
    "bullets": [],
    "callout": ""
  },
  {
    "title": "2. Qué hace Loop",
    "body": "Loop es una plataforma tecnológica para descubrir negocios, publicar servicios, gestionar reservas, administrar agendas, registrar pagos, usar reportes, membresías, créditos, fidelidad y comunicaciones cuando estén activas.",
    "bullets": [],
    "callout": "Loop no presta directamente los servicios publicados. Cada negocio es responsable por la prestación, calidad, disponibilidad, precios, políticas, impuestos, atención y solución comercial de sus servicios."
  },
  {
    "title": "3. Uso por clientes",
    "body": "",
    "bullets": [
      "Debes ser mayor de edad para crear una cuenta y reservar en Loop.",
      "Debes proporcionar datos reales y actualizados, incluyendo nombre, correo y teléfono.",
      "Antes de reservar, revisa negocio, servicio, precio, duración, fecha, hora, ubicación, política de cancelación y condiciones de pago.",
      "No debes usar Loop para fraude, spam, suplantación, abuso, información falsa o actividades ilegales."
    ],
    "callout": ""
  },
  {
    "title": "4. Uso por negocios",
    "body": "Si registras o administras un negocio, confirmas que tienes autorización para hacerlo. El negocio es responsable por su perfil público, servicios, precios, agenda, trabajadores, permisos, clientes, políticas comerciales, comunicaciones y cumplimiento de obligaciones legales aplicables.",
    "bullets": [
      "Debes mantener servicios, horarios, precios, capacidad y trabajadores actualizados.",
      "Debes respetar los datos de clientes y usar accesos de trabajadores de forma segura.",
      "Debes atender disputas relacionadas con el servicio, calidad, cancelaciones, no-show y reembolsos.",
      "Debes pagar a Loop los planes, comisiones, módulos premium, automatizaciones o cargos acordados."
    ],
    "callout": ""
  },
  {
    "title": "5. Reservas",
    "body": "Las reservas pueden crearse por clientes, por negocios o por herramientas internas de agenda. Una reserva puede estar pendiente, confirmada, completada, cancelada, rechazada, no asistida u otro estado equivalente según el flujo activo.",
    "bullets": [
      "El negocio puede aprobar, rechazar, modificar o cancelar reservas según disponibilidad y políticas.",
      "Loop puede mostrar disponibilidad basada en la configuración del negocio, pero no garantiza atención en todos los casos.",
      "El cliente debe revisar confirmaciones, cambios, recordatorios y cancelaciones enviadas por Loop o el negocio."
    ],
    "callout": ""
  },
  {
    "title": "6. Pagos y cargos",
    "body": "Loop puede operar con pago registrado, cuando el negocio cobra por fuera o presencialmente y Loop solo registra el estado; y con pago online, cuando Loop facilita cobros con tarjeta u otros métodos mediante proveedores de pago como Wompi, si el negocio lo activa.",
    "bullets": [
      "Cada negocio define precios, anticipos, saldos, penalidades, no-show, devoluciones y condiciones comerciales.",
      "Loop puede cobrar a negocios suscripciones, comisiones por reserva, comisiones por pagos procesados, cargos por módulos premium, comunicaciones o automatizaciones.",
      "Los cargos de procesadores de pago, impuestos, contracargos u otros costos pueden aplicar de forma separada.",
      "El pago de un plan o comisión a Loop no garantiza ventas, clientes, reservas ni resultados comerciales."
    ],
    "callout": ""
  },
  {
    "title": "7. Cancelaciones, no-show y reembolsos",
    "body": "Las políticas de cancelación, no-show y reembolso son definidas principalmente por cada negocio. Loop puede facilitar información técnica de la reserva y del pago, pero la decisión comercial y la atención final corresponden al negocio, salvo obligaciones legales aplicables.",
    "bullets": [],
    "callout": ""
  },
  {
    "title": "8. Membresías, créditos y fidelidad",
    "body": "Los negocios pueden ofrecer membresías, paquetes, créditos, sellos, puntos o beneficios. El negocio define precio, vigencia, uso, devolución, congelamiento, vencimiento y restricciones. Loop facilita el registro y seguimiento, pero no garantiza el valor comercial del beneficio ofrecido por el negocio.",
    "bullets": [],
    "callout": ""
  },
  {
    "title": "9. Comunicaciones",
    "body": "Loop y los negocios pueden enviar confirmaciones, recordatorios, cancelaciones, avisos operativos, soporte y comunicaciones relacionadas por email, WhatsApp, push u otros canales. Algunas comunicaciones son necesarias para operar reservas y cuenta.",
    "bullets": [],
    "callout": ""
  },
  {
    "title": "10. Datos, privacidad y seguridad",
    "body": "El tratamiento de datos personales se explica en nuestra Política de privacidad. Los negocios deben usar los datos de clientes solo para fines legítimos relacionados con reservas, servicio, soporte, fidelidad, membresías o comunicaciones permitidas.",
    "bullets": [],
    "callout": ""
  },
  {
    "title": "11. Limitaciones",
    "body": "Loop se ofrece como plataforma tecnológica. No garantizamos disponibilidad ininterrumpida, ausencia absoluta de errores, resultados comerciales, volumen de clientes ni la calidad de servicios prestados por terceros. Podemos pausar funciones por mantenimiento, seguridad, abuso, impago o requisitos legales.",
    "bullets": [],
    "callout": ""
  },
  {
    "title": "12. Cambios a estos términos",
    "body": "Podemos actualizar estos términos cuando agreguemos funciones, pagos, módulos, obligaciones comerciales o requisitos legales. Si el cambio es material, podremos solicitar una nueva aceptación dentro de la app antes de continuar usando la plataforma.",
    "bullets": [],
    "callout": ""
  }
];

function plainText() {
  return ["Loop Reservas — Términos y condiciones.", `Versión: ${LOOP_LEGAL_TERMS_VERSION}`, `Actualización: ${LOOP_LEGAL_UPDATED_LABEL}`, "", ...SECTIONS.flatMap((section) => [section.title, section.body || "", ...(section.bullets || []).map((item) => `- ${item}`), section.callout ? `Nota: ${section.callout}` : "", ""]), `Contacto: ${LOOP_SUPPORT_EMAIL}`].filter((line, idx, arr) => line !== "" || arr[idx - 1] !== "").join("\n");
}

function downloadTextFile(filename, text) {
  try { const blob = new Blob([text], { type: "text/plain;charset=utf-8" }); const url = URL.createObjectURL(blob); const a = document.createElement("a"); a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url); } catch (_) {}
}

const legalPageStyles = `
  .loop-legal-page { min-height: calc(100vh - 88px); background: radial-gradient(circle at 8% 0%, rgba(0,103,95,.12), transparent 30%), radial-gradient(circle at 92% 12%, rgba(251,247,239,.95), transparent 34%), linear-gradient(180deg,#fbfdfc 0%,#fff 48%,#f8fbfa 100%); padding: clamp(26px,4.5vw,68px) 18px 70px; color:#0b1220; box-sizing:border-box; }
  .loop-legal-wrap { width:min(1080px,100%); margin:0 auto; }
  .loop-legal-card { background:rgba(255,255,255,.94); border:1px solid rgba(207,225,222,.95); border-radius:34px; box-shadow:0 30px 90px rgba(15,23,42,.08); padding:clamp(26px,4vw,56px); overflow:hidden; }
  .loop-legal-topline { display:flex; align-items:flex-start; justify-content:space-between; gap:18px; margin-bottom:28px; }
  .loop-legal-kicker { color:#00675f; font-size:12px; font-weight:950; letter-spacing:.17em; text-transform:uppercase; margin-bottom:12px; }
  .loop-legal-title { margin:0; color:#0b1220; font-size:clamp(40px,5vw,68px); line-height:.96; letter-spacing:-.075em; font-weight:950; }
  .loop-legal-subtitle { margin:18px 0 0; color:#64748b; font-size:16px; line-height:1.65; font-weight:700; max-width:790px; }
  .loop-legal-version { flex:0 0 auto; border:1px solid rgba(0,103,95,.14); background:#f0fdfa; color:#00675f; border-radius:999px; padding:10px 13px; font-size:12px; font-weight:950; white-space:nowrap; }
  .loop-legal-actions { display:flex; flex-wrap:wrap; gap:9px; margin:24px 0 6px; }
  .loop-legal-actions button, .loop-legal-actions a { border:1px solid rgba(0,103,95,.16); background:#fff; color:#00675f; border-radius:999px; padding:10px 13px; font-size:12px; font-weight:950; text-decoration:none; cursor:pointer; }
  .loop-legal-actions .primary, .loop-legal-actions button.primary { background:#00675f; color:#fff; }
  .loop-legal-summary { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:12px; margin:26px 0 8px; }
  .loop-legal-pill-card { border:1px solid rgba(207,225,222,.95); border-radius:22px; background:rgba(248,252,251,.86); padding:17px; }
  .loop-legal-pill-card strong { display:block; color:#0f172a; font-size:14px; font-weight:950; margin-bottom:6px; }
  .loop-legal-pill-card span { display:block; color:#64748b; font-size:13px; line-height:1.45; font-weight:700; }
  .loop-legal-content { margin-top:30px; display:grid; gap:24px; }
  .loop-legal-section { padding-top:24px; border-top:1px solid rgba(226,232,240,.95); }
  .loop-legal-section h2 { margin:0 0 10px; color:#0f172a; font-size:22px; line-height:1.18; font-weight:950; letter-spacing:-.035em; }
  .loop-legal-section p, .loop-legal-section li { color:#475569; font-size:15px; line-height:1.72; font-weight:650; }
  .loop-legal-section p { margin:0; }
  .loop-legal-section ul { margin:10px 0 0; padding-left:22px; }
  .loop-legal-section li + li { margin-top:7px; }
  .loop-legal-callout { margin-top:16px; border:1px solid rgba(0,103,95,.18); background:rgba(240,253,250,.82); color:#00675f; border-radius:22px; padding:16px 18px; font-size:14px; line-height:1.55; font-weight:850; }
  .loop-legal-warning { margin-top:16px; border:1px solid rgba(245,158,11,.24); background:rgba(255,251,235,.86); color:#92400e; border-radius:22px; padding:16px 18px; font-size:14px; line-height:1.55; font-weight:850; }
  .loop-legal-contact { display:inline; color:#00675f; font-weight:950; text-decoration:none; }
  .loop-legal-contact:hover { text-decoration:underline; }
  .loop-legal-note { margin-top:30px; padding:17px 19px; border-radius:22px; background:#f0fdfa; border:1px solid rgba(0,103,95,.16); color:#00675f; font-size:14px; line-height:1.5; font-weight:850; }
  @media (max-width:860px){ .loop-legal-summary{grid-template-columns:1fr;} .loop-legal-topline{display:block;} .loop-legal-version{display:inline-flex;margin-top:18px;} }
  @media (max-width:640px){ .loop-legal-page{padding:20px 12px calc(var(--loop-mobile-nav-height,72px) + 24px);} .loop-legal-card{border-radius:26px;padding:24px 18px;} .loop-legal-title{font-size:39px;letter-spacing:-.06em;} }
  @media print { .loop-legal-page{background:#fff!important;padding:0!important;} .loop-legal-card{box-shadow:none!important;border:0!important;border-radius:0!important;} .loop-legal-actions{display:none!important;} }
`;

export default function TermsPage() {
  return (
    <>
      <style>{legalPageStyles}</style>
      <main className="loop-legal-page">
        <div className="loop-legal-wrap">
          <section className="loop-legal-card">
            <div className="loop-legal-topline">
              <div>
                <div className="loop-legal-kicker">Términos</div>
                <h1 className="loop-legal-title">Términos y condiciones.</h1>
                <p className="loop-legal-subtitle">Un documento único para clientes y negocios: uso de la plataforma, reservas, pagos, suscripciones, comisiones, cancelaciones, no-show, reembolsos, membresías, créditos y fidelidad.</p>
              </div>
              <div className="loop-legal-version">{LOOP_LEGAL_TERMS_VERSION}</div>
            </div>

            <div className="loop-legal-actions">
              <button type="button" className="primary" onClick={() => window.print()}>Imprimir / PDF</button>
              <button type="button" onClick={() => downloadTextFile("loop-terminos-condiciones.txt", plainText())}>Descargar TXT</button>
              <a href="/terms">Términos</a>
              <a href="/privacy">Privacidad</a>
              <a href="/payments">Pagos</a>
              <a href={`mailto:${LOOP_SUPPORT_EMAIL}`}>Soporte</a>
            </div>

            <div className="loop-legal-summary">
              <div className="loop-legal-pill-card"><strong>Clientes</strong><span>Reglas claras para reservar, pagar, cancelar y recibir comunicaciones.</span></div>
              <div className="loop-legal-pill-card"><strong>Negocios</strong><span>Responsabilidad sobre agenda, servicios, precios, clientes, pagos a Loop y atención final.</span></div>
              <div className="loop-legal-pill-card"><strong>Pagos</strong><span>Pago registrado hoy y pago online con proveedor cuando el negocio lo active.</span></div>
            </div>

            <div className="loop-legal-content">
              {SECTIONS.map((section) => (
                <div className="loop-legal-section" key={section.title}>
                  <h2>{section.title}</h2>
                  {section.body ? <p>{section.body}</p> : null}
                  {section.bullets && section.bullets.length ? <ul>{section.bullets.map((item) => <li key={item}>{item}</li>)}</ul> : null}
                  {section.callout ? <div className="loop-legal-callout">{section.callout}</div> : null}
                </div>
              ))}
            </div>
            <div className="loop-legal-note">Última actualización: {LOOP_LEGAL_UPDATED_LABEL}. Contacto oficial: <a className="loop-legal-contact" href={`mailto:${LOOP_SUPPORT_EMAIL}`}>{LOOP_SUPPORT_EMAIL}</a>.</div>
          </section>
        </div>
      </main>
    </>
  );
}
